import { render, staticRenderFns } from "./MarketingPortalPage.vue?vue&type=template&id=6ab07a9f&"
import script from "./MarketingPortalPage.vue?vue&type=script&lang=js&"
export * from "./MarketingPortalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports